import { clsx } from 'clsx'

/**
 * A tag, read out.
 *
 * Tags are stored folded to `lower_snake_case` so that one word has one
 * spelling and a rule can match it. That folding is an implementation detail,
 * so it is undone here rather than on every card.
 */
export function TagChip({
  tag,
  className,
}: {
  tag: string
  className?: string
}) {
  return (
    <span
      className={clsx(
        'rounded-full bg-surface-sunken px-2 py-0.5 text-micro text-ink-soft ring-1 ring-line',
        className,
      )}
    >
      {tag.replace(/_/g, ' ')}
    </span>
  )
}

export function TagList({
  tags,
  empty = 'No tags',
  className,
}: {
  tags: string[]
  empty?: string
  className?: string
}) {
  if (tags.length === 0) {
    return <span className="text-ink-faint">{empty}</span>
  }
  return (
    <span className={clsx('flex flex-wrap gap-1', className)}>
      {tags.map((tag) => (
        <TagChip key={tag} tag={tag} />
      ))}
    </span>
  )
}